import { apiFetch } from './client';

export const checkForAppUpdate = async () => apiFetch('/api/update/check');

export const installAppUpdate = async () => apiFetch('/api/update/install', {
    method: 'POST',
  });
